/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Pricing_CtaInputs */

const en_st_pricing_cta = /** @type {(inputs: St_Pricing_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About Studio`)
};

const id_st_pricing_cta = /** @type {(inputs: St_Pricing_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentang Studio`)
};

/**
* | output |
* | --- |
* | "About Studio" |
*
* @param {St_Pricing_CtaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_pricing_cta = /** @type {((inputs?: St_Pricing_CtaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Pricing_CtaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_pricing_cta(inputs)
	return en_st_pricing_cta(inputs)
});